import { Div } from '../../../base/components/native/div'

export const Redemption = (item: any) => {

    const base = Div()
    const amount = Div('میزان استفاده: ' + item.amount)
    const date = Div(new Date(item.at).toLocaleDateString())
    base.append(amount, date)

    date.cssClass({
        color: '#adacac'
    })
    base.cssClass({
        marginTop: '20px',
    })

    return base
}